export default "__VITE_ASSET__yG9htwTb__"